import React from 'react'
import { cn } from 'oddle-shop-monorepo.design-system'

type BaseProps = {
  children: React.ReactNode
  className?: string
  ref?: React.Ref<HTMLDivElement>
}

const Container = ({ children, className = '', ref }: BaseProps) => (
  <div
    className={cn(
      'mx-auto max-w-[calc(100vw-16px)] pl-2 pr-2 lg:max-w-[1200px] lg:pl-4 lg:pr-4',
      className
    )}
    ref={ref}
  >
    {children}
  </div>
)

const Section = ({ children, className = '' }: BaseProps) => (
  <div className={cn('my-6 block w-full', className)}>{children}</div>
)

// Create the compound component
const ResponsiveSection = Object.assign(Section, {
  Container,
})

export default ResponsiveSection
